import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import { fetchAdApis } from "../../services/axios/apiManager";
import AdsApisList from "./adsApisList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";

const AdsApis = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [adsApis, setAdsApis] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);
  const [loading, setLoading] = useState(true);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Ads_APIs");
    if (perms) {
      setGranted(perms);
    }
  };
  const getData = async () => {
    const res = await fetchAdApis();
    if (res?.data?.success && res?.data?.data) {
      setAdsApis(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    setLoading(false);
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Ads Api
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="d-flex justify-content-center">
            <LoadingSpinner size={"lg"} />
          </div>
        ) : (
          <AdsApisList
            adsApis={adsApis}
            setAdsApis={setAdsApis}
            pagination={pagination}
            setPagination={setPagination}
            granted={granted}
          />
        )}
      </div>
    </DashboardLayout>
  );
};
export default AdsApis;
